var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "breadcrumb-wrapper" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
        _c(
          "ol",
          { staticClass: "breadcrumb px-0" },
          _vm._l(_vm.data.breadcrumbItems, function(item, index) {
            return _c(
              "li",
              { key: "breadcrumb" + index, staticClass: "breadcrumb-item" },
              [
                index == _vm.data.breadcrumbItems.length - 1
                  ? _c("span", [
                      _vm._v(
                        "\n            " + _vm._s(item.text) + "\n          "
                      )
                    ])
                  : _c("span", [
                      _c(
                        "a",
                        {
                          staticClass: "ltr-underline",
                          attrs: { href: item.url }
                        },
                        [_vm._v(_vm._s(item.text))]
                      )
                    ])
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }